import { APIParser, APIParserNoMsg, APIDownloadFile } from "./api-parser";
import { API_URL, NEW_API_URL } from "./api-client";
import { getToken } from "./api-util";
import triyoAPI from "./triyo";

const authMvc = window["APP_SETTINGS"].AUTH_MVC;

const config = (method, header) => {
  let token = getToken();
  return {
    method: method,
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// GETS
export const GetAllDepartments = (searchQuery) => {
  let searchQueryJSON = JSON.stringify(searchQuery);

  return fetch(API_URL + "getalldepartments/" + "0", {
    method: "POST",
    body: searchQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetBlankDepartmentQuery = () => {
  return new Promise((resolve, reject) => {
    resolve({
      pageSize: 10,
      pageNumber: 1,
      sortDesc: false,
      sortBy: "name",
      filters: [],
    });
  });
};

export const GetDepartment = (departmentID) => {
  if (authMvc === "TRUE") {
    return fetch(API_URL + "GetDepartment/" + "0" + "/" + departmentID, {
      method: "GET",
      credentials: "include",
    }).then((response) => APIParser(response));
  } else {
    let myHeaders = new Headers();
    let token = getToken();
    myHeaders.append("Authorization", `Bearer ${token}`);

    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(NEW_API_URL + "user/legacy/department", requestOptions).then(
      (response) => APIParser(response)
    );
  }
};

export const DownloadDepartments = () => {
  return fetch(API_URL + "DownloadDepartments/" + "0", {
    method: "GET",
    credentials: "include",
  }).then((response) => APIDownloadFile(response));
};

// DELETE
export const DeleteDepartment = async (deleteIDs) => {
  let departmentJson = JSON.stringify(deleteIDs);

  return await fetch(API_URL + "deletedepartments/" + 1, {
    method: "POST",
    body: departmentJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParserNoMsg(response));
};

export const GetDepartmentAPI = (data) => {
  return triyoAPI.get(
    `/department/GetDepartmentById?departmentId=${data}`,
    config()
  );
};

export const EditDepartmentAPI = (data) => {
  return triyoAPI.post(`/department/EditDepartment`, data, config("POST"));
};

export const CreateDepartmentAPI = (data) => {
  return triyoAPI.post(`/department/CreateDepartment`, data, config("POST"));
};

export const DeleteSelectedDepartments = (data) => {
  return triyoAPI.post(`/department/RemoveSelectedDepartments`, data, config("POST"));
};

export const DeleteSelectedDepartment = (data) => {
  return triyoAPI.post(`/department/RemoveSelectedDepartment`, data, config("POST"));
};

export const DeleteDepartmentAPI = (ids) => {
  let data = { deletedIds: ids.join() };
  return triyoAPI.post(`/department/RemoveDepartment`, data, config("POST"));
};

export const DownloadDepartmentAPI = () => {
  return triyoAPI.get(`/department/DownloadDepartment`, config("GET"));
};

export const GetAllDepartmentsAPI = (data) => {
  return triyoAPI.get(
    `/department/GetAllDepartments?filter=${JSON.stringify(data)}`,
    config("GET")
  );
};

export const GetDepartmentFiltersAPI = () => {
  return triyoAPI.get(`/department/GetDepartmentFilters`, config());
};

export const GetAllDepartmentsForCreateScreen = (data) => {
  let obj = {
    Filters: JSON.stringify(data),
  };
  return triyoAPI.post(
    `/department/GetAllDepartmentsForCreateScreen`,
    obj,
    config("POST")
  );
};

export const GetAllDepartmentsForTemplateScreen = (data) => {
  let obj = {
    Filters: JSON.stringify(data),
  };
  return triyoAPI.post(
    `/department/GetAllDepartmentsForTemplateScreen`,
    obj,
    config("POST")
  );
};

export const GetUsersByDepartmentId = (companyId) => {
  return triyoAPI.get(
    `/department/GetUsersByDepartmentId?companyId=${companyId}`,
    config("GET")
  );
};

export const DepartmentExistsWithNameAPI = (data) => {
  return triyoAPI.get(
    `/department/GetDepartmentByName?departmentName=${data}`,
    config("GET")
  );
};

export const AllSubDepartmentsFromDepartment = (id) => {
  return triyoAPI.get(
    `/SubDepartment/GetSubDepartmentByDepartmentId?DepartmentId=${id}`,
    config("GET")
  );
}

export const GetAllDepartmentsForTelerikGrid = (data) => {
  return triyoAPI.post(`/department/GetAllDepartmentsForTelerikGrid`, data, config("POST", true));
};
